import api from './api';

// Dünner Wrapper um die globale Datensuche (GET /admin/search?q=) — der Endpunkt entsteht
// parallel im Backend; Pfad-/Format-Korrekturen bleiben damit auf diese eine Datei begrenzt.
// Vertrag: { query, groups: [{ key, label, items: [{ type, id, title, subtitle, status }] }] }
// — leere Gruppen fehlen, serverseitig max. 5 Treffer pro Gruppe, Rechte bereits gefiltert.
export const searchAdminData = async (q) => {
  const response = await api.get('/admin/search', { params: { q } });
  const groups = Array.isArray(response.data?.groups) ? response.data.groups : [];
  return { query: response.data?.query ?? q, groups };
};
